import { useAISuggestionRequest } from 'hooks/queries/articles/aiSuggestionsRequests/useAISuggestionRequest'
import { SuggestionRequestStatus, SuggestionRequestWithRequester } from 'types'
import { UseQueryOptions } from 'react-query'

interface Props {
  articleId: string
  layerId: string
  id: number
}

interface Options extends Omit<UseQueryOptions<{ request: SuggestionRequestWithRequester }>, 'refetchInterval'> {
  intervalMs?: number
}

export const usePollAISuggestionRequest = ({ articleId, layerId, id }: Props, options?: Options) => {
  return useAISuggestionRequest(
    { articleId, layerId, id },
    {
      refetchInterval: (data) => {
        if (
          data?.request.status !== undefined &&
          [
            SuggestionRequestStatus.Successful,
            SuggestionRequestStatus.Failed,
            SuggestionRequestStatus.Aborted,
            SuggestionRequestStatus.Expired,
          ].includes(data.request.status)
        ) {
          return false
        }

        return options?.intervalMs || 500
      },
      ...options,
    },
  )
}
